import { ReactElement } from "react";
import { IBarChartConfig, ILineChartConfig, IPieConfig } from "../../components/charts/types";
import FilterComponentBase from "../../components/filterComponentBase";
import BarChart from "../../components/charts/barChart";
import LineChart from "../../components/charts/lineChart";
import { getPalette } from "../../configuration/configuration";
import PieChart from "../../components/charts/pieChart";

const oneHundred = 100;
const getRandomNumber = () => Math.random() * oneHundred;

interface IAlarmsDashboardProps {
  parentSize: {
    width: number;
    height: number;
  };
}

const AlarmsDashboard = ({ parentSize }: IAlarmsDashboardProps): ReactElement => {

  const pieConfig: IPieConfig = {
    maximum: 0,
    padAngle: 0.05,
    innerRadius: 0.1,
    seriesRadius: 1.2,
    series: [
      { name: "A", value: 25, color: "#3e8ef7" },
      { name: "B", value: 40, color: "#0bb2d4" },
      { name: "C", value: 35, color: "#17b3a3" }
    ]
  };

  const pieConfig2: IPieConfig = {
    maximum: 1000,
    padAngle: 0.05,
    innerRadius: 0.5,
    seriesRadius: 1.2,
    series: [
      { name: "A", value: 250, color: "#3e8ef7" },
      { name: "B", value: 340, color: "#0bb2d4" },
      { name: "C", value: 170, color: "#17b3a3" }
    ]
  };

  const barChartConfig: IBarChartConfig = {
    width: 600,
    height: 100,
    xAxis: {
      name: "X",
      ticksAngle: 15,
      categories: ["Product A", "Product B", "Product C", "Product D", "Product E", "Product F"],
    },
    yAxis: [{
      name: "Y",
      minimum: 0,
      maximum: 400,
      ticksCount: 3,
      formatTick: (value) => (value as number).toFixed(2)
    }],
    title: "Bar Chart",
    series: [
      { name: "Product A", value: 250, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.indigo },
      { name: "Product B", value: 340, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.cyan },
      { name: "Product C", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.deepPurple },
      { name: "Product D", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.orange },
      { name: "Product E", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.lime },
      { name: "Product F", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.pink }
    ],
  };

  const lineChartConfig: ILineChartConfig = {
    // width: 300,
    height: 100,
    xAxis: {
      name: "X",
      minimum: 0,
      maximum: 50,
      ticksCount: 6,
      formatTick: (value) => (value as number).toFixed(2)
    },
    yAxis: [{
      name: "Y",
      minimum: 0,
      maximum: 100,
      ticksCount: 3,
      formatTick: (value) => (value as number).toFixed(2)
    }],
    title: "Line Chart",
    series: [
      { name: "A",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.pink,
        type: "area"
      },
      { name: "B",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.lightBlue,
      },
      { name: "C",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.purple,
      }
    ]
  };


  return (
    <div className="display-flex-column" style={{ ...parentSize }}>
      <FilterComponentBase loading={false}/>

      <div className="display-flex-row flex-wrap justify-content-space-around w-100 m-3">
        <PieChart pieConfig={pieConfig} />
        <PieChart pieConfig={pieConfig2} />
      </div>

      <div className=" m-3 p-3" style={{ display: "grid", gridTemplateColumns: "auto 1fr", columnGap: "1em" }}>
        <BarChart barChartConfig={barChartConfig}/>
        <LineChart lineChartConfig={lineChartConfig}/>
      </div>

    </div>
  );

};

export default AlarmsDashboard;
